// Size validations
$("#creditor_requisition, #creditor_proof_of_residence, #creditor_doc").on('change', function(){
  const size = (this.files[0].size / 1024 / 1024).toFixed(2);

  if (size > 10) {
    $(this).prev().find('li').text("Arquivo muito grande!");
    $(this).val('');
  }
});

$('[data-toggle="popover"]').popover({
  trigger: 'focus'
});